import React, { Component } from 'react';

class Http404 extends Component {
  render() {
    return (
      <div>
        <h2>Page Not Found</h2> 
      </div>
    )
  }
}
export default Http404;



// WEBPACK FOOTER //
// ./src/errors/Http404.js